import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=0db2e05d&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=0db2e05d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2e05d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db2e05d')) {
      api.createRecord('0db2e05d', component.options)
    } else {
      api.reload('0db2e05d', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=0db2e05d&scoped=true&", function () {
      api.rerender('0db2e05d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G6Ie01j45s70/JS/comp/Paginate.vue"
export default component.exports